const WX_STATIC_ORIGIN = "https://hzshixiang.site";

/**
 * 与小程序 wxStaticUrl 一致：/static/image/… → CDN …/jxupload/wxStatic/…
 */
export function wxStaticUrl(path) {
  if (path == null || path === "") return "";
  let p = String(path).trim();
  if (!p) return "";
  if (/^https?:\/\//i.test(p)) return p;
  if (p.startsWith("@/static/image/")) {
    p = "/static/image/" + p.slice("@/static/image/".length);
  }
  if (p.startsWith("/static/image/")) {
    return `${WX_STATIC_ORIGIN}/jxupload/wxStatic/${p.slice("/static/image/".length)}`;
  }
  if (p.startsWith("/report/")) {
    return `${WX_STATIC_ORIGIN}/jxupload/wxStatic${p}`;
  }
  if (p.startsWith("/static/")) {
    return `${WX_STATIC_ORIGIN}/jxupload/wxStatic/${p.slice("/static/".length)}`;
  }
  return `${WX_STATIC_ORIGIN}/jxupload/wxStatic/${p.replace(/^\//, "")}`;
}



// WEBPACK FOOTER //
// ./src/util/wxStaticUrl.js